import { render, staticRenderFns } from "./HistoryWriteDefaultLayout.vue?vue&type=template&id=8a8448aa&scoped=true&"
import script from "./HistoryWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./HistoryWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8448aa",
  null
  
)

export default component.exports